import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { faClose, faCookieBite } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { consentActions } from '../../state/consent';
import { ImportsModule } from '../imports.module';

@Component({
  selector: 'cookie-policy-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImportsModule,
    RouterModule
  ]
})
export class CookiePolicyBannerComponent {
  private readonly store = inject(Store);

  protected readonly icons = {
    faCookieBite,
    faClose
  } as const;

  protected acceptEssential(): void {
    this.store.dispatch(consentActions.setConsent({ consent: 'essential' }));
  }

  protected acceptAll(): void {
    this.store.dispatch(consentActions.setConsent({ consent: 'all' }));
  }
}